import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';
import store from '@/store/index';

// KTU_MM_DGLH_O
export const calculateDGLHO = () => {
    let result: number = 0;

    const dglhO = helper.GetMainCharacteristicValue('KTU_MM_DGLH_O', contex.Measure);
    const hasTopPanel = helper.HasTopPanel();

    if (hasTopPanel === true) {
        result = dglhO;
    }

    return result;
};

// KTU_MM_O_BREITE
export const calculateOBREITE = () => {
    let result: number = 0;

    const mlb = helper.GetMainCharacteristicValue('KTU_MM_MLB', contex.Measure);

    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const HasOberblende  = helper.HasTopPanel();

    if(HasOberblende)
    {
        switch (fireResistance) {
            case '30':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = mlb - 44 + 28 - 8 + 30;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = mlb - 44 + 28 - 8 + 30 - 20 - 20;
                        break;
                    case '4':
                        result = mlb - 44 + 28 - 8 + 30 - 40 - 40;
                        break;
                    default:
                        break;
                }
                break;
            case '0':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = mlb - 24 + 28 - 8 + 30;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = mlb - 24 + 28 - 8 + 30 - 20 - 20;
                        break;
                    case '4':
                        result = mlb - 24 + 28 - 8 + 30 - 40 - 40;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }
    return result;
};

// KTU_MM_TUERBLATTHOEHE
export const calculateTUERBLATTHOEHE = () => {
    let result: number = 0;

    const bmlh = helper.GetMainCharacteristicValue('KTU_MM_BMLH', contex.Measure);
    const dglho = helper.GetMainCharacteristicValue('KTU_MM_DGLH_O', contex.Measure);

    const hasTopPanel = helper.HasTopPanel();
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);

    if (hasTopPanel === false) {
        switch (fireResistance) {
            case '30':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = bmlh - 22 + 14 - 3 + 15 - 8;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = bmlh - 22 + 14 - 3 + 15 - 8 - 20;
                        break;
                    case '4':
                        result = bmlh - 22 + 14 - 3 + 15 - 8 - 40;
                        break;
                    default:
                        break;
                }
                break;
            case '0':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = bmlh - 12 + 14 - 3 + 15 - 8;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = bmlh - 12 + 14 - 3 + 15 - 8 - 20;
                        break;
                    case '4':
                        result = bmlh - 12 + 14 - 3 + 15 - 8 - 40;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    } else {
        switch (model) {
            case 'CERT':
                result = dglho + 15 - 3 - 8;
                break;
            case 'BERT':
            case 'VERT':
                result = dglho + 15 + 15 - 3 - 8;
                break;
            default:
                break;
        }
    }

    return result;
};

// KTU_MM_TUERBLATTHOEHE_MIT_O
export const calculateTUERBLATTHOEHEMITO = () => {
    let result: number = 0;

    const bmlh = helper.GetMainCharacteristicValue('KTU_MM_BMLH', contex.Measure);

    const hasTopPanel = helper.HasTopPanel();
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const topPanelLockThumb = helper.GetDependencyValueCode('KTU_MM_O_STUMPF', contex.Measure);

    if (hasTopPanel === false) {
        switch (fireResistance) {
            case '30':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = bmlh - 22 + 14 - 3 + 15 - 8;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = bmlh - 22 + 14 - 3 + 15 - 8 - 20;
                        break;
                    case '4':
                        result = bmlh - 22 + 14 - 3 + 15 - 8 - 40;
                        break;
                    default:
                        break;
                }
                break;
            case '0':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = bmlh - 12 + 14 - 3 + 15 - 8;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = bmlh - 12 + 14 - 3 + 15 - 8 - 20;
                        break;
                    case '4':
                        result = bmlh - 12 + 14 - 3 + 15 - 8 - 40;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    } else {
        switch (topPanelLockThumb) {
            case 'NEIN':
                switch (fireResistance) {
                    case '30':
                        switch (wallType) {
                            case '5':
                            case '6':
                            case '7':
                                result = bmlh - 22 + 14 - 3 + 15 - 8;
                                break;
                            case '1':
                            case '2':
                            case '3':
                                result = bmlh - 22 + 14 - 3 + 15 - 8 - 20;
                                break;
                            case '4':
                                result = bmlh - 22 + 14 - 3 + 15 - 8 - 40;
                                break;
                            default:
                                break;
                        }
                        break;
                    case '0':
                        switch (wallType) {
                            case '5':
                            case '6':
                            case '7':
                                result = bmlh - 12 + 14 - 3 + 15 - 8;
                                break;
                            case '1':
                            case '2':
                            case '3':
                                result = bmlh - 12 + 14 - 3 + 15 - 8 - 20;
                                break;
                            case '4':
                                result = bmlh - 12 + 14 - 3 + 15 - 8 - 40;
                                break;
                            default:
                                break;
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 'JA':
                result = bmlh - 3 - 8;
                break;
            default:
                break;
        }
    }

    return result;
};

// KTU_MM_O_HOEHE
export const calculateOHOEHE = () => {
    let result: number = 0;

    const bmlh = helper.GetMainCharacteristicValue('KTU_MM_BMLH', contex.Measure);
    const dglho = helper.GetMainCharacteristicValue('KTU_MM_DGLH_O', contex.Measure);
    const tuerblattHoeheMitO = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE_MIT_O', contex.Measure);
    const tuerblattHoehe = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure);

    const hasTopPanel = helper.HasTopPanel();
    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const topPanelThumbLock = helper.GetDependencyValueCode('KTU_MM_O_STUMPF', contex.Measure);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    if (hasTopPanel === true) {
        switch (topPanelThumbLock) {
            case 'NEIN':
                if (model === 'CERT' && doorWings === 'D2') {
                    result = tuerblattHoeheMitO - tuerblattHoehe + 11.5 - 3;
                } else if (model === 'CERT' && doorWings === 'D1') {
                    result = tuerblattHoeheMitO - tuerblattHoehe + 11.5;
                } else {
                    result = tuerblattHoeheMitO - tuerblattHoehe + 11.5 + 15;
                }
                break;
            case 'JA':
                result = bmlh - 3 - dglho;
                break;
            default:
                break;
        }
    } else {
        result = result; // 0
    }

    return result;
};

// KTU_MM_DGLB_90_GEHFLUEGEL
export const calculateDGLB90GEHFLUEGEL = () => {
    let result: number = 0;

    const tuerblattBreiteGes = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE_GES', contex.Measure);
    const dglb90Gehfluegel = helper.GetMainCharacteristicValue('KTU_MM_DGLB_90_GEHFLUEGEL', contex.Measure);

    const trafficDoorWidthAsym = store.state.measureModule.model.trafficDoor.WidthAsym;

    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorSymmetry = helper.GetDependencyValueCode('CUST_MM_TUER_MASS_SYM', contex.Measure);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    if (doorWings === 'D2') {
        switch (doorSymmetry) {
            case 'SY':
                if (model === 'CERT') {
                    result = (tuerblattBreiteGes / 2) - 60;
                } else {
                    result = (tuerblattBreiteGes / 2 + 17) - 64;
                }
                break;
            case 'ASY':
                if (model === 'CERT') {
                    // result = dglb90Gehfluegel + 60;
                    // result = Number(trafficDoorWidthAsym) + 60;
                    result = Number(trafficDoorWidthAsym);
                } else {
                    // result = dglb90Gehfluegel + 64;
                    // result = Number(trafficDoorWidthAsym) + 64;
                    result = Number(trafficDoorWidthAsym);
                }
                break;
            default:
                break;
        }
    } else {
        result = result; // 0
    }

    return result;
};

// KTU_MM_STAFFEL_HOEHE
export const calculateSTAFFELHOEHE = () => {
    let result: number = 0;

    const thresholdHeight = helper.GetMainCharacteristicValue('KTU_MM_STAFFEL_HOEHE', contex.Measure);
    const niveauHoehe = helper.GetMainCharacteristicValue('KTU_MM_NIVEAU_HOEHE', contex.Measure);

    const thresholdForm = helper.GetDependencyValueCode('CUST_MM_STAFFEL_FORM', contex.Measure);
    const niveauArt = helper.GetDependencyValueCode('KTU_MM_NIVEAU_ART', contex.Measure);

    switch (thresholdForm) {
        case 'KEIN':
            result = result; // 0
            break;
        case 'STD':
            switch (niveauArt) {
                case 'A':
                    result = 20;
                    break;
                case 'B':
                    result = niveauHoehe + 20;
                    break;
                case 'C':
                    result = 20;
                    break;
                default:
                    break;
            }
            break;
        case 'HS':
            switch (niveauArt) {
                case 'A':
                    result = 30;
                    break;
                case 'B':
                    result = niveauHoehe + 30;
                    break;
                case 'C':
                    result = 30;
                    break;
                default:
                    break;
            }
            break;
        case 'VS':
            switch (niveauArt) {
                case 'A':
                    result = thresholdHeight;
                    break;
                case 'B':
                    result = thresholdHeight;
                    break;
                case 'C':
                    result = thresholdHeight;
                    break;
                default:
                    break;
            }
            break;
        case 'BS':
            result = 0; // 0
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_STAFFEL_BREITE
export const calculateSTAFFELBREITE = () => {
    let result: number = 0;

    const stlb = helper.GetMainCharacteristicValue('KTU_MM_STLB', contex.Measure);
    const thresholdForm = helper.GetDependencyValueCode('CUST_MM_STAFFEL_FORM', contex.Measure);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);

    switch (thresholdForm) {
        case 'KEIN':
            result = result; // 0
            break;
        case 'STD':
            switch (frameForm) {
                case 'ES':
                case 'EB':
                case 'ES-SST':
                case 'EB-SST':
                case 'ES-SV1':
                case 'EB-SV1':
                case 'ES-SV2':
                case 'EB-SV2':
                    result = stlb + 50;
                    break;
                case 'UB':
                case 'USB':
                    result = stlb;
                    break;
                case 'US':
                case 'UBS':
                    result = stlb;
                    break;
                default:
                    break;
            }
            break;
        case 'HS':
            switch (frameForm) {
                case 'ES':
                case 'EB':
                case 'ES-SST':
                case 'EB-SST':
                case 'ES-SV1':
                case 'EB-SV1':
                case 'ES-SV2':
                case 'EB-SV2':
                    result = stlb + 50;
                    break;
                case 'UB':
                case 'USB':
                    result = stlb;
                    break;
                case 'US':
                case 'UBS':
                    result = stlb;
                    break;
                default:
                    break;
            }
            break;
        case 'VS':
            switch (frameForm) {
                case 'ES':
                case 'EB':
                case 'ES-SST':
                case 'EB-SST':
                case 'ES-SV1':
                case 'EB-SV1':
                case 'ES-SV2':
                case 'EB-SV2':
                    result = stlb + 50;
                    break;
                case 'UB':
                case 'USB':
                    result = stlb;
                    break;
                case 'US':
                case 'UBS':
                    result = stlb;
                    break;
                default:
                    break;
            }
            break;
        case 'BS':
            result = result; // 0
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_STAFFEL_TIEFE
export const calculateSTAFFELTIEFE = () => {
    let result: number = 0;

    const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Functions);
    const thresholdHeight = helper.GetMainCharacteristicValue('KTU_MM_STAFFEL_HOEHE', contex.Measure);

    const thresholdForm = helper.GetDependencyValueCode('CUST_MM_STAFFEL_FORM', contex.Measure);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const niveauArt = helper.GetDependencyValueCode('KTU_MM_NIVEAU_ART', contex.Measure);

    switch (thresholdForm) {
        case 'KEIN':
            result = result; // 0
            break;
        case 'STD':
            switch (niveauArt) {
                case 'A':
                    result = wallWidth + 50;
                    break;
                case 'B':
                    result = wallWidth + 50;
                    break;
                case 'C':
                    result = wallWidth + 50;
                    break;
                default:
                    break;
            }
            break;
        case 'HS':
            switch (frameForm) {
                case 'ES':
                case 'EB':
                case 'ES-SST':
                case 'EB-SST':
                case 'ES-SV1':
                case 'EB-SV1':
                case 'ES-SV2':
                case 'EB-SV2':
                    result = wallWidth + 10;
                    break;
                case 'UB':
                case 'USB':
                    result = wallWidth + 45;
                    break;
                case 'US':
                case 'UBS':
                    result = wallWidth + 30;
                    break;
                default:
                    result = wallWidth;
                    break;
            }
            break;
        case 'VS':
            switch (niveauArt) {
                case 'A':
                    result = 10;
                    break;
                case 'B':
                    result = 10;
                    break;
                case 'C':
                    result = 10;
                    break;
                default:
                    break;
            }
            break;
        case 'BS':
            result = result; // 0
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_AUSFAELZUNG
export const calculateAUSFAELZUNG = () => {
    let result: number = 0; // AUSFAELZUNG
    const thresholdHeight = helper.GetMainCharacteristicValue('KTU_MM_STAFFEL_HOEHE', contex.Measure);
    const niveauHoehe = helper.GetMainCharacteristicValue('KTU_MM_NIVEAU_HOEHE', contex.Measure);
    const thresholdHeightBS = store.state.measureModule.model.threshold.HeightValueBS;

    const thresholdForm = helper.GetDependencyValueCode('CUST_MM_STAFFEL_FORM', contex.Measure);
    const niveauArt = helper.GetDependencyValueCode('KTU_MM_NIVEAU_ART', contex.Measure);

    const falzgeometrie = helper.GetDependencyValueCode('KTU_MM_FALZGEOMETRIE', contex.Functions);
    if(falzgeometrie === 'F') {
        result = 0;
    }
    else {
        switch (thresholdForm) {
            case 'KEIN':
                result = result; // 0
                break;
            case 'STD':
                switch (niveauArt) {
                    case 'A':
                        result = niveauHoehe + 20;
                        break;
                    case 'B':
                        result = 20;
                        break;
                    case 'C':
                        result = 20;
                        break;
                    default:
                        break;
                }
                break;
            case 'HS':
                switch (niveauArt) {
                    case 'A':
                        result = niveauHoehe + 30;
                        break;
                    case 'B':
                        result = 30;
                        break;
                    case 'C':
                        result = 30;
                        break;
                    default:
                        break;
                }
                break;
            case 'VS':
                switch (niveauArt) {
                    case 'A':
                        result = thresholdHeight;
                        break;
                    case 'B':
                        result = thresholdHeight;
                        break;
                    case 'C':
                        result = thresholdHeight;
                        break;
                    default:
                        break;
                }
                break;
            case 'BS':
                switch (niveauArt) {
                    case 'A':
                        // result = thresholdHeight + niveauHoehe;
                        result = Number(thresholdHeightBS) + niveauHoehe;
                        break;
                    case 'B':
                        // result = thresholdHeight - niveauHoehe;
                        result = Number(thresholdHeightBS) - niveauHoehe;
                        if (result < 0) {
                            result = 0;
                        }
                        break;
                    case 'C':
                        // result = thresholdHeight;
                        result = Number(thresholdHeightBS);
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }




    return result;
};

// KTU_MM_TUERBLATTBREITE_GES
export const calculateTUERBLATTBREITEGES = () => {
    let result: number = 0;

    const mlb = helper.GetMainCharacteristicValue('KTU_MM_MLB', contex.Measure);

    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);

    switch (fireResistance) {
        case '30':
            switch (wallType) {
                case '5':
                case '6':
                case '7':
                    result = mlb - 44 + 28 - 8 + 30;
                    break;
                case '1':
                case '2':
                case '3':
                    result = mlb - 44 + 28 - 8 + 30 - 20 - 20;
                    break;
                case '4':
                    result = mlb - 44 + 28 - 8 + 30 - 40 - 40;
                    break;
                default:
                    break;
            }
            break;
        case '0':
            switch (wallType) {
                case '5':
                case '6':
                case '7':
                    result = mlb - 24 + 28 - 8 + 30;
                    break;
                case '1':
                case '2':
                case '3':
                    result = mlb - 24 + 28 - 8 + 30 - 20 - 20;
                    break;
                case '4':
                    result = mlb - 24 + 28 - 8 + 30 - 40 - 40;
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_TUERBLATTBREITE
export const calculateTUERBLATTBREITE = () => {
    let result: number = 0;

    const mlb = helper.GetMainCharacteristicValue('KTU_MM_MLB', contex.Measure);
    const dglb90Gehfluegel = helper.GetMainCharacteristicValue('KTU_MM_DGLB_90_GEHFLUEGEL', contex.Measure);
    const tuerBlattBreite = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE_GES', contex.Measure);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const doorSymmetry = helper.GetDependencyValueCode('CUST_MM_TUER_MASS_SYM', contex.Measure);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);

    if (doorWings === 'D1') {
        switch (fireResistance) {
            case '30':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = mlb - 44 + 28 - 8 + 30;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = mlb - 44 + 28 - 8 + 30 - 20 - 20;
                        break;
                    case '4':
                        result = mlb - 44 + 28 - 8 + 30 - 40 - 40;
                        break;
                    default:
                        break;
                }
                break;
            case '0':
                switch (wallType) {
                    case '5':
                    case '6':
                    case '7':
                        result = mlb - 24 + 28 - 8 + 30;
                        break;
                    case '1':
                    case '2':
                    case '3':
                        result = mlb - 24 + 28 - 8 + 30 - 20 - 20;
                        break;
                    case '4':
                        result = mlb - 24 + 28 - 8 + 30 - 40 - 40;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    } else {
        switch (doorSymmetry) {
            case 'SY':
                if (model === 'CERT') {
                    result = tuerBlattBreite / 2;
                } else {
                    result = (tuerBlattBreite / 2) + 17;
                }
                break;
            case 'ASY':
                if (model === 'CERT') {
                    result = dglb90Gehfluegel + 60;
                } else {
                    result = dglb90Gehfluegel + 64;
                }
                break;
            default:
                break;
        }
    }

    return result;
};

// KTU_MM_GEHFLUEGEL_BREITE
export const calculateGEHFLUEGELBREITE = () => {
    // debugger;
    let result: number = 0;

    const dglb90Gehfluegel = helper.GetMainCharacteristicValue('KTU_MM_DGLB_90_GEHFLUEGEL', contex.Measure);
    const tuerBlattBreite = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE_GES', contex.Measure);
    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorSymmetry = helper.GetDependencyValueCode('CUST_MM_TUER_MASS_SYM', contex.Measure);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    // debugger;
    if (doorWings === 'D2') {
        switch (doorSymmetry) {
            case 'SY':
                if (model === 'CERT') {
                    result = tuerBlattBreite / 2;
                } else {
                    result = (tuerBlattBreite / 2) + 17;
                }
                break;
            case 'ASY':
                if (model === 'CERT') {
                    result = dglb90Gehfluegel + 60;
                } else {
                    result = dglb90Gehfluegel + 64;
                }
                break;
            default:
                break;
        }
    } else {
        result = result; // 0
    }

    return result;
};

// KTU_MM_TUERBLATTBREITE_STEHFLG
export const calculateTUERBLATTBREITESTEHFLG = () => {
    // debugger;
    let result: number = 0;

    const gehfluegelBreite = helper.GetMainCharacteristicValue('KTU_MM_GEHFLUEGEL_BREITE', contex.Measure);
    const tuerBlattBreite = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE_GES', contex.Measure);
    const doorSymmetry = helper.GetDependencyValueCode('CUST_MM_TUER_MASS_SYM', contex.Measure);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    // debugger;
    if (doorWings === 'D2') {
        switch (doorSymmetry) {
            case 'SY':
                result = tuerBlattBreite - 3.5 - gehfluegelBreite;
                break;
            case 'ASY':
                result = tuerBlattBreite - 3.5 - gehfluegelBreite;
                break;
            default:
                break;
        }
    } else {
        result = result; // 0
    }

    return result;
};

// KTU_MM_TUERBLATTHOEHE_OHNE_O
export const calculateTUERBLATTHOEHEOHNEO = () => {
    let result: number = 0;

    const topPanelHeight = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure);
    result = topPanelHeight;

    return result;
};

// KTU_MM_ZARGEN_HOEHE_BS
export const calculateZARGENHOEHEBS = () => {
    let result: number = 0;

    const bmlh = helper.GetMainCharacteristicValue('KTU_MM_BMLH', contex.Measure);
    const bdlh = helper.GetMainCharacteristicValue('KTU_MM_BDLH', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const topPanelLockThumb = helper.GetDependencyValueCode('KTU_MM_O_STUMPF', contex.Measure);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (frameForm) {
                case 'EB-SST':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 12;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 12;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'ES-SST':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 12;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 12;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'EB-SV1':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 14;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 14;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'ES-SV1':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 14;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 14;
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh;
                            break;
                        case 'JA':
                            result = bmlh - 3;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (frameForm) {
                case 'EB-SST':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 12;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 12;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'ES-SST':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 12;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 12;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'EB-SV1':
                    switch (fireResistance) {
                        case '30':
                            switch (topPanelLockThumb) {
                                case 'NEIN':
                                    result = bdlh + 24;
                                    break;
                                case 'JA':
                                    result = bmlh - 3 + 24;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case '0':
                            switch (topPanelLockThumb) {
                                case 'NEIN':
                                    result = bdlh + 14;
                                    break;
                                case 'JA':
                                    result = bmlh - 3 + 14;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        default:
                            break;
                    }
                    break;
                case 'ES-SV1':
                    switch (fireResistance) {
                        case '30':
                            switch (topPanelLockThumb) {
                                case 'NEIN':
                                    result = bdlh + 24;
                                    break;
                                case 'JA':
                                    result = bmlh - 3 + 24;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case '0':
                            switch (topPanelLockThumb) {
                                case 'NEIN':
                                    result = bdlh + 14;
                                    break;
                                case 'JA':
                                    result = bmlh - 3 + 14;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh;
                            break;
                        case 'JA':
                            result = bmlh - 3;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '6':
        case '7':
            switch (frameForm) {
                case 'EB-SST':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 12;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 12;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'EB-SV1':
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh + 14;
                            break;
                        case 'JA':
                            result = bmlh - 3 + 14;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'EB-SV2':
                    switch (fireResistance) {
                        case '30':
                            switch (topPanelLockThumb) {
                                case 'NEIN':
                                    result = bdlh + 3;
                                    break;
                                case 'JA':
                                    result = bmlh - 3 + 3;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case '0':
                            switch (topPanelLockThumb) {
                                case 'NEIN':
                                    result = bdlh + 13;
                                    break;
                                case 'JA':
                                    result = bmlh - 3 + 13;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    switch (topPanelLockThumb) {
                        case 'NEIN':
                            result = bdlh;
                            break;
                        case 'JA':
                            result = bmlh - 3;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        default:
            switch (topPanelLockThumb) {
                case 'NEIN':
                    result = bdlh;
                    break;
                case 'JA':
                    result = bmlh - 3;
                    break;
                default:
                    break;
            }
            break;
    }

    return result;
};

// KTU_MM_ZARGEN_HOEHE_GBS
export const calcualteZARGENHOEHEGBS = () => {
    let result: number = 0;

    const gbdlh = helper.GetMainCharacteristicValue('KTU_MM_GBDLH', contex.Measure);
    const topPanelLockThumb = helper.GetDependencyValueCode('KTU_MM_O_STUMPF', contex.Measure);

    switch (topPanelLockThumb) {
        case 'NEIN':
            result = gbdlh;
            break;
        case 'JA':
            result = gbdlh - 3;
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_ZARGEN_BREITE
export const calculateZARGENBREITE = () => {
    let result: number = 0;

    const stlb = helper.GetMainCharacteristicValue('KTU_MM_STLB', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (frameForm) {
                case 'EB-SST':
                    result = stlb + 24;
                    break;
                case 'ES-SST':
                    result = stlb + 24;
                    break;
                case 'EB-SV1':
                    result = stlb + 28;
                    break;
                case 'ES-SV1':
                    result = stlb + 28;
                    break;
                default:
                    result = stlb;
                    break;
            }
            break;
        case '4':
            switch (frameForm) {
                case 'EB-SST':
                    result = stlb + 24;
                    break;
                case 'ES-SST':
                    result = stlb + 24;
                    break;
                case 'EB-SV1':
                    switch (fireResistance) {
                        case '30':
                            result = stlb + 48;
                            break;
                        case '0':
                            result = stlb + 28;
                            break;
                        default:
                            break;
                    }
                    break;
                case 'ES-SV1':
                    switch (fireResistance) {
                        case '30':
                            result = stlb + 48;
                            break;
                        case '0':
                            result = stlb + 28;
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    result = stlb;
                    break;
            }
            break;
        case '6':
        case '7':
            switch (frameForm) {
                case 'EB-SST':
                    result = stlb + 24;
                    break;
                case 'EB-SV1':
                    result = stlb + 28;
                    break;
                case 'EB-SV2':
                    switch (fireResistance) {
                        case '30':
                            result = stlb + 6;
                            break;
                        case '0':
                            result = stlb + 26;
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    result = stlb;
                    break;
            }
            break;
        default:
            result = stlb;
            break;
    }

    return result;
};

// KTU_MM_FUTTERPLATTE_S_BREITE
export const calculateFUTTERPLATTESBREITE = () => {
    let result: number = 0;

    const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Functions);

    const futterplatteS = helper.GetDependencyValueCode('KTU_MM_FUTTERPLATTE_S', contex.Frame);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);

    if (futterplatteS !== 'NEIN') {
        switch (frameForm) {
            case 'ES':
            case 'EB':
                result = 0;
                break;
            case 'UB':
            case 'UBS':
                result = wallWidth + 2 + 10;
                break;
            case 'US':
            case 'USB':
                result = wallWidth - 27 + 10;
                break;
            default:
                result = 0;
                break;
        }
    } else {
        result = 0;
    }

    return result;
};

// KTU_MM_FUTTERPLATTE_S_LAENGE
export const calculateFUTTERPLATTESLAENGE = () => {
    let result: number = 0;

    const frameHeightFront = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_HOEHE_BS', contex.Measure);
    const frameHeightBack = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_HOEHE_GBS', contex.Measure);

    const futterplatteS = helper.GetDependencyValueCode('KTU_MM_FUTTERPLATTE_S', contex.Frame);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);

    if (futterplatteS !== 'NEIN') {
        switch (frameForm) {
            case 'ES':
            case 'EB':
                result = 0;
                break;
            case 'UB':
            case 'UBS':
                result = Math.max(frameHeightFront, frameHeightBack);
                break;
            case 'US':
            case 'USB':
                result = Math.max(frameHeightFront, frameHeightBack);
                break;
            default:
                result = 0;
                break;
        }
    } else {
        result = 0;
    }

    return result;
};

// KTU_MM_FUTTERPLATTE_W_BREITE
export const calculateFUTTERPLATTEWBREITE = () => {
    let result: number = 0;

    const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Functions);

    const futterplatteW = helper.GetDependencyValueCode('KTU_MM_FUTTERPLATTE_W', contex.Frame);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);

    if (futterplatteW !== 'NEIN') {
        switch (frameForm) {
            case 'ES':
            case 'EB':
                result = 0;
                break;
            case 'UB':
            case 'UBS':
                result = wallWidth + 2 + 10;
                break;
            case 'US':
            case 'USB':
                result = wallWidth - 27 + 10;
                break;
            default:
                result = 0;
                break;
        }
    } else {
        result = 0;
    }

    return result;
};

// KTU_MM_FUTTERPLATTE_W_LAENGE
export const calculateFUTTERPLATTEWLAENGE = () => {
    let result: number = 0;

    // // Start snippet from calculateSTLB
    // let xSTLB: number = 0;
    // let frameW1: number = 0;
    // let frameW2: number = 0;
    // let sonderstockW1: number = 0;
    // let sonderstockW2: number = 0;
    // let sonderstockW: number = 0;
    // let blindstockW1: number = 0;
    // let fermacellW1: number = 0;

    // frameW1 = helper.GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
    // frameW2 = helper.GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
    // sonderstockW1 = helper.GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
    // sonderstockW2 = helper.GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
    // blindstockW1 = helper.GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
    // fermacellW1 = helper.GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');
    // sonderstockW = helper.GetDependencyValueCode('KTU_MM_BLINDSTOCK', contex.Frame) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

    // const selectedWall = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    // if (selectedWall !== '5') {
    //     xSTLB = 2 * (frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
    // } else {
    //     xSTLB = 2 * ( frameW1 + frameW2 + fermacellW1 );
    // }
    // // End snippet from calculateSTLB

    const stlb = helper.GetMainCharacteristicValue('KTU_MM_STLB', contex.Measure);
    const futterplatteW = helper.GetDependencyValueCode('KTU_MM_FUTTERPLATTE_W', contex.Frame);
    const zargeKurzform = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM',contex.Frame);

    var haveFutterplate = false;
    
    if(zargeKurzform === "US" || zargeKurzform === "UB" || zargeKurzform === "UBS" || zargeKurzform === "USB")
    {
        haveFutterplate = true;
    }

    if (futterplatteW !== 'NEIN' && haveFutterplate === true) {
        result = stlb + 10;
    } else {
        result = 0;
    }

    return result;
};

export const calculateFERMACELLSLAENGE = () => {
    let result: number = 0;
    const fermacellBreieteTeilA = helper.GetMainCharacteristicValue('KTU_MM_FERMACELL_BREITE_A_TEIL', contex.Frame);
    const bmlh = helper.GetMainCharacteristicValue('KTU_MM_BMLH', contex.Measure);
    const gbmlh = helper.GetMainCharacteristicValue('KTU_MM_GBMLH', contex.Measure);

    if(fermacellBreieteTeilA != 0){
        result = Math.max(bmlh,gbmlh)
    }
    return result;
}

export const calculateFERMACELLWLAENGE = () => {
    let result: number = 0;
    const fermacellBreieteTeilA = helper.GetMainCharacteristicValue('KTU_MM_FERMACELL_BREITE_A_TEIL', contex.Frame);
    const mlb = helper.GetMainCharacteristicValue('KTU_MM_MLB', contex.Measure);

    if(fermacellBreieteTeilA != 0){
        result = mlb
    }
    return result;
}

//KTU_MM_TUERBAND_ANZ
export const calculateTuerBandANZ = () => {
    let result: number = 0;
    const articleNumber = helper.GetDependencyValueCode('KTU_MM_ARTIKELNR', contex.ModelSelection );
    const tuerblatHohe = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure);
    var isOneWingDoor = false;
    var isTwoWingDoor = false;

    if(articleNumber.includes("D1"))
    {
        isOneWingDoor = true;
    }else {
        isTwoWingDoor = true;
    }

    if(isOneWingDoor)
    {
        result = 4;
    }

    if(isOneWingDoor  && tuerblatHohe >= 2300)
    {
        result = 5;
    }

    if(isTwoWingDoor)
    {
        result = 8;
    }

    if(isTwoWingDoor && tuerblatHohe >= 2300)
    {
        result = 10;
    }

    return result;
}